import React, { Component } from 'react';
import { connect } from "react-redux";

class PartialCount extends Component {

    onClickPartialCount() {
        let param = this.props.oscillator.partialCountParameter;
        param.set(
            (param.get() + 1) % param.max);
    }

    render() {
        let osc = this.props.oscillator;
        return (
            <div className="partial-count-container">
              <div
                onClick={() => this.onClickPartialCount()}
                className="partial-count">
                {this.props.value}
              </div>
              <div>
                Partials
              </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let parameter = props.oscillator.partialCountParameter;
    let value = 
        props.automation === undefined ||
        props.automation.get(parameter) === undefined
        ? state.effects.effectParameters[parameter.id] :
        props.automation.get(parameter).value;

    return {
        value: value
    };
}

export default connect(mapStateToProps, null)(PartialCount);


